import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import Navbar from 'react-bootstrap/Navbar';
import { polyglot } from '../../assets/locales';
import { bcLogo, headerPointer } from '../../assets/images';
import ROUTES from '../../constants/RouteConstants';

const getSubHeaderText = (currentPath) => {
  if (currentPath === ROUTES.EXPLORER_STEP1 || currentPath === ROUTES.EXPLORER_STEP2) return polyglot.t('header.subHeaderTextExplorer');
  if (currentPath === ROUTES.NOTICEGEN_STEP1 || currentPath === ROUTES.NOTICEGEN_STEP1) return polyglot.t('header.subHeaderTextNoticeGenerator');
  if (currentPath === ROUTES.LANDLORD_VALIDATOR) return polyglot.t('header.subHeaderLandlordValidator');
  if (currentPath === ROUTES.TENANT_VALIDATOR) return polyglot.t('header.subHeaderTenantValidator');
  if (currentPath === ROUTES.RENT_INCREASE_CALCULATOR) return polyglot.t('header.subHeaderRentIncreaseCalculator');
  
  return;
};

const Header = (props) => {
  const { pathname, hash } = props;
  const currentPath = pathname.concat(hash);

  useEffect(() => {
    if (currentPath.includes(ROUTES.EXPLORER)) document.title = 'Rent Increase Explorer';
    else if (currentPath.includes(ROUTES.NOTICEGEN)) document.title = 'Rent Increase Notice Generator';
  }, [currentPath]);

  if (!currentPath.includes(ROUTES.EXPLORER) && !currentPath.includes(ROUTES.NOTICEGEN) && !currentPath.includes(ROUTES.LANDLORD_VALIDATOR) && !currentPath.includes(ROUTES.TENANT_VALIDATOR) && !currentPath.includes(ROUTES.RENT_INCREASE_CALCULATOR) ) return<></>;

  return (
    <div className="headers">
      <div className="header">
        <Navbar className="header-bar">
          <img className="header-icon" src={bcLogo} alt="" />
        </Navbar>
      </div>
      <div className="header-sub">
        <Navbar className="header-sub-bar">
          <span>{polyglot.t('header.headerText')}</span>
          <div className="header-pointer">
            <img className="header-pointer-img" src={headerPointer} alt="" />
          </div>
        </Navbar>
      </div>
      <div className="header-explore">
        <Navbar className="header-explore-bar">
          <span className="header-explore-bar-text">{getSubHeaderText(currentPath)}</span>
        </Navbar>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  pathname: state.router.location.pathname,
  hash: state.router.location.hash,
});

export default connect(mapStateToProps)(Header);
